import { postReceipts } from "../../../../services/Aeat.jsx";
import Button from "../../button/Button.jsx";
import Modal from "../Modal.jsx";

import { useState } from "react";
import Divider from "../../aesthetics/Divider.jsx";
import TableRefused from "../../table/TableRefused.jsx";

const STATES = { CONFIRM: "confirm", LOADING: "loading", RESULT: "result" };
const initial_result = { "accepted": [], "refused": [] };

const ModalAceptacion = ({ isOpen, onClose, refetch, receipts }) => {
  const [state, setState] = useState(STATES.CONFIRM);
  const [result, setResult] = useState(initial_result);

  const handleConfirmOnClick = async (e) => {
    setState(STATES.LOADING);
    e.preventDefault();
    try {
      // const receiptIds = { receipts: receipts.map(obj => obj.id) };
      // const response = await postReceipts(receiptIds);

      const half = Math.floor(receipts.length / 2);
      const test_accepted = receipts.slice(0, half).map(obj => ({
        receipt: obj.id,
      }));
      const test_refused = receipts.slice(half).map(obj => ({
        receipt: obj.id,
        arc: obj.arc,
        errors: [["Code", "Fault SOAP", "Detail"]],
      }));

      const response = { accepted: test_accepted, refused: test_refused };
      console.log("response (fake):", response);

      const acceptedIds = new Set(response.accepted.map(r => r.receipt));
      const refusedIds = new Set(response.refused.map(r => r.receipt));

      const refusedErrorsById = response.refused.reduce((acc, r) => {
        acc[r.receipt] = r.errors ?? [];
        return acc;
      }, {});

      const accepted = receipts
        .filter(r => acceptedIds.has(r.id))
        .map(r => ({
          lrn: r.lrn,
          arc: r.arc,
        }));

      const refused = receipts
        .filter(r => refusedIds.has(r.id))
        .map(r => ({
          lrn: r.lrn,
          arc: r.arc,
          errors: refusedErrorsById[r.id] ?? [],
        }));

      const nextResult = { accepted, refused };
      setResult(nextResult); // ⚠️ setState es async, no confíes en result justo después
      console.log("nextResult:", nextResult);
      setState(STATES.RESULT);
    } catch (e) {
      console.log(e.message);
      setState(STATES.RESULT);
    }
  };

  const totalOk = result.accepted?.length ?? 0;
  const totalRefused = result.refused?.length ?? 0;

  const canDismiss = state !== STATES.LOADING;

  return (
    <Modal isOpen={isOpen} onClose={onClose} canDismiss={canDismiss}>
      {state === STATES.CONFIRM && (
        <>
          <div>
            <h1 className="font-bold">Acepación de Documentos de Acompañamiento</h1>
            <span>Se van a aceptar los siguientes documentos:</span>
            <ul className="py-4 list-disc list-inside text-gray-800">
              {receipts.map((item, index) => <li key={index}>{item.lrn}, {item.arc}</li>)}
            </ul>
          </div>
          <div className="flex justify-center gap-4">
            <Button onClick={handleConfirmOnClick}>Confirmar</Button>
            <Button onClick={onClose}>Cancelar</Button>
          </div>
        </>
      )}
      {state === STATES.LOADING && (
        <>
          <h1 className="font-bold">Acepación de Documentos de Acompañamiento</h1>
          <span>Aceptando los documentos de acompañamiento...</span>
          <p className="mt-2 text-sm text-gray-600">No cierres esta ventana.</p>
          <div className="mt-6 animate-pulse">⏳</div>
        </>
      )}
      {state === STATES.RESULT && (
        <>
          <div>
            <h1 className="font-bold">Acepación de Documentos de Acompañamiento</h1>
            <span>Resultado de la aceptación:</span>
            <h2 className="font-bold">{totalOk > 0 ? "Aceptados correctamente" : "Sin aceptaciones"}</h2>
            <ul className="py-4 list-disc list-inside text-gray-800">
              {result.accepted.map((item, index) => <li key={index}>{item.lrn}, {item.arc}</li>)}
            </ul>
            <Divider />
            <h2 className="font-bold">{totalRefused > 0 ? "No aceptados" : "Sin rechazos"}</h2>
            <TableRefused items={result.refused} />
          </div>
          <div className="py-2 flex justify-center gap-4">
            <Button
              onClick={() => {
                onClose();
                refetch();
              }}
            >
              Cerrar
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ModalAceptacion;
